<div id="main-nav" class="navbar" style="position: relative!important; top:0px!important;">
  <div class="container">

    <div class="navbar-header">

      <button type="button" class="navbar-toggle" data-toggle="collapse" data-target="#site-nav">
        <span class="icon-bar"></span><span class="icon-bar"></span><span class="icon-bar"></span>
      </button>

      <!-- ======= LOGO ========-->
      <a class="navbar-brand scrollto" href="#home">
        <span class="logo-small">
          <img src="assets/images/alpata-logo.png" alt="" />
        </span>
        <span class="to-top"><i class="fa fa-arrow-up"></i></span>
      </a>

    </div>

    <div id="site-nav" class="navbar-collapse collapse">
      <ul class="nav navbar-nav navbar-right">
        <li class="sr-only">
          <a href="en#home" class="scrollto">HOME</a>
        </li>
        <li>
          <a href="en#about" class="scrollto">ABOUT</a>
        </li>
        <li>
          <a href="en#portfolio" class="scrollto">COMPANIES</a>
        </li>
        <li>
          <a href="en#hr" class="scrollto">CAREER</a>
        </li>
        <li>
          <a href="en#contact" class="scrollto">CONTACT US</a>
        </li>
        <li>
          <a>|</a>
        </li>
        <li>
          <a [routerLink]="['/']" routerLinkActive="router-link-active">
            <img src="assets/images/tr.jpg" title="Türkçe" />
          </a>
        </li>
        <li>
          <a [routerLink]="['/en']" routerLinkActive="router-link-active">
            <img src="assets/images/eng.jpg" title="İngilizce" />
          </a>
        </li>
        <!-- <li>

            <a href="https://www.ekatalog.gen.tr/katalog/alpata/" target="_blank" class="" style="color: #fff !important;
    font-size: 12px;
    font-weight: 600;
    background-color: #f70f0f !important;
    color: #002d62;
    line-height: 35px;
    margin-top: 15px;
    text-transform: capitalize;
    opacity: 1;
    border-radius: 5px;">
              2021 Takvim
            </a>
          </li> -->
      </ul>

    </div>
    <!--End navbar-collapse -->
  </div>
  <!--End container -->
</div>
<div style="background-image: url(/assets/images/fatura-bg.jpg); height: 300px;     background-position: left;
    text-align: center;
    align-content: center; color: #fff;">
  <div class="slider-overlay-2"></div>
  <h1 style="z-index: 10000; position: relative;">INVOICE INFORMATION OF ALPATA GROUP COMPANIES</h1>

</div>
<section id="portfolio-2" class="gray-bg padding-top-bottom ">
  <div class="container">
    <!--==== Portfolio Filters ====-->
    <div class="projects-container scrollimation">
      <div class="row">
        <article class="col-md-4 col-sm-6 project-item web-design apps psd">
          <div class="project-thumb in " data-id="246a96e9-6da5-4eba-8da2-b84c2416892a">
            <a href="#f-alpata" class="main-link" (click)="GetCompanyCities(1)">
              <img class="img-responsive img-center"
                src="assets/images/company/246a96e9-6da5-4eba-8da2-b84c2416892a.tr.png" alt="" />
              <h2 class="project-title">NECDET ALPATA MARKETING LOGISTICS AND TOURISM INDUSTRY AND TRADE INC.</h2>
              <span class="overlay-mask"></span>
            </a>
            <a class="link centered" (click)="GetCompanyCities(1)"><i class="fa fa-eye fa-fw"></i></a>
          </div>
        </article>
        <article class="col-md-4 col-sm-6 project-item web-design apps psd">
          <div class="project-thumb in" data-id="3ad20862-0226-4548-ac82-e6487120c922">
            <a href="#f-otomotiv" class="main-link" (click)="GetCompanyCities(2)">
              <img class="img-responsive img-center"
                src="assets/images/company/3ad20862-0226-4548-ac82-e6487120c922.tr.png" alt="" />
              <h2 class="project-title">NECDET ALPATA AS. AUTOMOTIVE BRANCH</h2>
              <span class="overlay-mask"></span>
            </a>
            <a class="link centered" (click)="GetCompanyCities(2)"><i class="fa fa-eye fa-fw"></i></a>
          </div>
        </article>
        <article class="col-md-4 col-sm-6 project-item web-design apps psd">
          <div class="project-thumb in " data-id="2073de91-8cbe-4d99-adea-6305b30c2184">
            <a href="#f-sigorta" class="main-link" (click)="GetCompanyCities(3)">
              <img class="img-responsive img-center"
                src="assets/images/company/2073de91-8cbe-4d99-adea-6305b30c2184.tr.png" alt="" />
              <h2 class="project-title">AALPATA INSURANCE BROKERAGE COMPANY</h2>
              <span class="overlay-mask"></span>
            </a>
            <a class="link centered" (click)="GetCompanyCities(3)"><i class="fa fa-eye fa-fw"></i></a>
          </div>
        </article>
        <article class="col-md-4 col-sm-6 project-item web-design apps psd">
          <div class="project-thumb in " data-id="cbb2a481-ddfc-4850-88ff-95b98b4efeef">
            <a href="#f-havacilik" class="main-link" (click)="GetCompanyCities(4)">
              <img class="img-responsive img-center"
                src="assets/images/company/cbb2a481-ddfc-4850-88ff-95b98b4efeef.tr.png" alt="" />
              <h2 class="project-title">ALP AVIATION</h2>
              <span class="overlay-mask"></span>
            </a>
            <a class="link centered" (click)="GetCompanyCities(4)"><i class="fa fa-eye fa-fw"></i></a>
          </div>
        </article>
        <article class="col-md-4 col-sm-6 project-item web-design apps psd">
          <div class="project-thumb in" data-id="b15c2ea5-5819-45f9-a196-4fbca8860f6c">
            <a href="#f-teknoloji" class="main-link" (click)="GetCompanyCities(5)">
              <img class="img-responsive img-center" src="assets/images/company/necdet-alpata-as-teknoloji-tr.png"
                alt="" />
              <h2 class="project-title">NECDET ALPATA AS. TECHNOLOGY BRANCH</h2>
              <span class="overlay-mask"></span>
            </a>
            <a class="link centered" (click)="GetCompanyCities(5)"><i class="fa fa-eye fa-fw"></i></a>
          </div>
        </article>

        <article class="col-md-4 col-sm-6 project-item web-design apps psd">
          <div class="project-thumb in  " data-id="9fd40c5f-aa8d-4da2-8cec-85374ab956e2">
            <a href="#f-alpteknik" class="main-link" (click)="GetCompanyCities(6)">
              <img class="img-responsive img-center"
                src="assets/images/company/9fd40c5f-aa8d-4da2-8cec-85374ab956e2.tr.png" alt="" />
              <h2 class="project-title">ALPTEKNIK AVIATION</h2>
              <span class="overlay-mask"></span>
            </a>
            <a class="link centered" (click)="GetCompanyCities(6)"><i class="fa fa-eye fa-fw"></i></a>
          </div>
        </article>
        <!-- <article class="col-md-4 col-sm-6 project-item web-design apps psd">
          <div class="project-thumb in  " data-id="b15c2ea5-5819-45f9-a196-4fbca8860f5c">
            <a href="#alpatasrl" class="main-link" (click)="GetCompanyCities(7)">
              <img class="img-responsive img-center"
                src="assets/images/company/b15c2ea5-5819-45f9-a196-4fbca8860f5c.tr.png" alt="" />
              <h2 class="project-title">ALPATA S.R.L</h2>
              <span class="overlay-mask"></span>
            </a>
            <a class="link centered" (click)="GetCompanyCities(7)"><i class="fa fa-eye fa-fw"></i></a>
          </div>
        </article> -->
        <div class="col-md-4 col-sm-6"></div>
        <article class="col-md-4 col-sm-6 project-item web-design apps psd">
          <div class="project-thumb in  " data-id="b15c2ea5-5819-45f9-a196-4fbca8860f5c">
            <a href="#f-alpatahavacilik" class="main-link" (click)="GetCompanyCities(8)">
              <img class="img-responsive img-center"
                src="assets/images/company/2073de91-8cbe-4d99-adea-6305b30c2185.tr.png" alt="" />
              <h2 class="project-title">ALPATA AEROSPACE</h2>
              <span class="overlay-mask"></span>
            </a>
            <a class="link centered" (click)="GetCompanyCities(8)"><i class="fa fa-eye fa-fw"></i></a>
          </div>
        </article>
      </div>
    </div>
  </div>
  <div *ngIf="gosterilenIsleme == 1" id="f-alpata">
    <div class="project-preview">
      <div class="container">
        <div class="preview-header text-center">
          <a href="#portfolio-2" class="close-preview" (click)="gosterilenIsletmeGosterGizle(1)">×</a>
          <p class="preview-subtitle"></p>
          <div id="f-alpata" class="col-sm-10 col-sm-offset-1" style="text-align:justify">
            <!-- <img class="img-responsive" style=" margin-bottom:30px;" src="assets/images/company/alpata.png"> -->
            <div class="fatura-card">
              <div class="fatura-card-header">
                <div style="position: relative; z-index: 3;">
                  <h1 class="mb-0">
                    NECDET ALPATA PAZARLAMA LOJİSTİK VE TURİZM SANAYİ VE TİCARET ANOMİN ŞİRKETİ
                  </h1>
                </div>
              </div>
              <div class="fatura-card-header-overlay"></div>
              <div class="card-body">
                <p><b class="primary">Billing Address: </b>Zafer Mahallesi Esener Sokak No:3 Tepebaşı / ESKİŞEHİR</p>
                <p><b class="primary">Tax Office: </b>ESKİŞEHİR DEFTERDARLIĞI</p>
                <p><b class="primary">Tax Number: </b>630 006 0282</p>
                <p><b class="primary">Phone: </b>0 (222) 323 89 00</p>
                <p><b class="primary">Fax: </b>0 (222) 322 13 14</p>
                <p><b class="primary">Mail: </b>info@alpata.com</p>
              </div>
            </div>
            <div class="fatura-footer">E-Invoice Registered</div>
          </div>
        </div>
        <div class="imac-frame hidden">
          <span class="loader"></span>
          <div class="imac-screen imac-slider flexslider"></div>
        </div>
      </div>
      <!--End container -->
    </div>
  </div>

  <div *ngIf="gosterilenIsleme == 2" id="f-otomotiv">
    <div class="project-preview">
      <div class="container">
        <div class="preview-header text-center">
          <a href="#portfolio-2" class="close-preview" (click)="gosterilenIsletmeGosterGizle(2)">×</a>
          <p class="preview-subtitle"></p>
          <div id="preview-content" class="col-sm-10 col-sm-offset-1" style="text-align:justify">
            <!-- <img class="img-responsive" style=" margin-bottom:30px;" src="assets/images/company/alpata.png"> -->
            <div class="fatura-card">
              <div class="fatura-card-header">
                <div style="position: relative; z-index: 3;">
                  <h1 class="mb-0">
                    NECDET ALPATA PAZARLAMA LOJİSTİK VE TURİZM SANAYİ VE TİCARET ANOMİN ŞİRKETİ OTOMOTİV ŞUBESİ
                  </h1>
                </div>
              </div>
              <div class="fatura-card-header-overlay"></div>
              <div class="card-body">
                <p><b class="primary">Billing Address: </b>Ankara Asfaltı 75.Yıl Mah. Çevreyolu Bulvarı No:2 Odunpazarı
                  /
                  ESKİŞEHİR</p>
                <p><b class="primary">Tax Office: </b>ESKİŞEHİR DEFTERDARLIĞI</p>
                <p><b class="primary">Tax Number: </b>630 006 0282</p>
                <p><b class="primary">Telefon: </b>0 (222) 228 03 30</p>
                <p><b class="primary">Fax: </b>0 (222) 228 03 39</p>
                <p><b class="primary">Mail: </b>opelsat@alpata.com </p>
              </div>
              <div class="fatura-footer">E-Invoice Registered</div>
            </div>
          </div>
        </div>
        <div class="imac-frame hidden">
          <span class="loader"></span>
          <div class="imac-screen imac-slider flexslider"></div>
        </div>
      </div>
      <!--End container -->
    </div>
  </div>

  <div *ngIf="gosterilenIsleme == 3" id="f-sigorta">
    <div class="project-preview">
      <div class="container">
        <div class="preview-header text-center">
          <a href="#portfolio-2" class="close-preview" (click)="gosterilenIsletmeGosterGizle(3)">×</a>
          <p class="preview-subtitle"></p>
          <div id="preview-content" class="col-sm-10 col-sm-offset-1" style="text-align:justify">
            <div class="fatura-card">
              <div class="fatura-card-header">
                <div style="position: relative; z-index: 3;">
                  <h1 class="mb-0">ALPATA SİGORTA ARACILIK HİZMETLERİ LİMİTED ŞİRKETİ</h1>
                </div>
              </div>
              <div class="fatura-card-header-overlay"></div>
              <div class="card-body">
                <p><b class="primary">Billing Address: </b>Ankara Asfaltı 75. Yıl Mah. Çevreyolu Bulvarı No:2 Odunpazarı
                  /
                  ESKİŞEHİR</p>
                <p><b class="primary">Tax Office: </b>ESKİŞEHİR DEFTERDARLIĞI</p>
                <p><b class="primary">Tax Number: </b>055 004 6564</p>
                <p><b class="primary">Telefon: </b>0 (222) 228 03 30</p>
                <p><b class="primary">Fax: </b>0 (222) 228 03 39</p>
                <p><b class="primary">Mail: </b>sigortainfo@alpata.com</p>
              </div>
              <div class="fatura-footer">E-Invoice Registered</div>
            </div>
          </div>
        </div>
        <div class="imac-frame hidden">
          <span class="loader"></span>
          <div class="imac-screen imac-slider flexslider"></div>
        </div>
      </div>
      <!--End container -->
    </div>
  </div>
  <div *ngIf="gosterilenIsleme == 4" id="f-havacilik">
    <div class="project-preview">
      <div class="container">
        <div class="preview-header text-center">
          <a href="#portfolio-2" class="close-preview" (click)="gosterilenIsletmeGosterGizle(4)">×</a>
          <p class="preview-subtitle"></p>
          <div id="preview-content" class="col-sm-10 col-sm-offset-1" style="text-align:justify">
            <!-- <img class="img-responsive" style=" margin-bottom:30px;" src="assets/images/company/alpata.png"> -->
            <div class="fatura-card">
              <div class="fatura-card-header">
                <div style="position: relative; z-index: 3;">
                  <h1 class="mb-0">ALP HAVACILIK SANAYİ VE TİCARET ANOMİN ŞİRKETİ</h1>
                </div>
              </div>
              <div class="fatura-card-header-overlay"></div>
              <div class="card-body">
                <p><b class="primary">Billing Address: </b>75.Yıl OSB Mahallesi 8. Cadde 26110 Odunpazarı / ESKİŞEHİR
                </p>
                <p><b class="primary">Tax Office: </b>ESKİŞEHİR DEFTERDARLIĞI</p>
                <p><b class="primary">Tax Number: </b>055 004 4545</p>
                <p><b class="primary">Telefon: </b>0 (222) 236 13 00</p>
                <p><b class="primary">Fax: </b>0 (222) 236 12 85</p>
                <p><b class="primary">Mail: </b>alphavacilik@alp.com.tr</p>
              </div>
              <div class="fatura-footer">E-Invoice Registered</div>
            </div>
          </div>
        </div>
        <div class="imac-frame hidden">
          <span class="loader"></span>
          <div class="imac-screen imac-slider flexslider"></div>
        </div>
      </div>
      <!--End container -->
    </div>
  </div>
  <div *ngIf="gosterilenIsleme == 5" id="f-teknoloji">
    <div class="project-preview">
      <div class="container">
        <div class="preview-header text-center">
          <a href="#portfolio-2" class="close-preview" (click)="gosterilenIsletmeGosterGizle(5)">×</a>
          <p class="preview-subtitle"></p>
          <div id="preview-content" class="col-sm-10 col-sm-offset-1" style="text-align:justify">
            <!-- <img class="img-responsive" style=" margin-bottom:30px;" src="assets/images/company/alpata.png"> -->
            <div class="fatura-card">
              <div class="fatura-card-header">
                <div style="position: relative; z-index: 3;">
                  <h1 class="mb-0">NECDET ALPATA PAZARLAMA LOJİSTİK VE TURİZM SANAYİ VE TİCARET ANOMİN ŞİRKETİ TEKNOLOJİ
                    ŞUBESİ</h1>
                </div>
              </div>
              <div class="fatura-card-header-overlay"></div>
              <div class="card-body">
                <p><b class="primary">Billing Address: </b>75.Yıl OSB Mahallesi Bilim Caddesi(Yazılım Kule) No:5 İç Kapı
                  No:401 Odunpazarı / ESKİŞEHİR</p>
                <p><b class="primary">Tax Office: </b>ESKİŞEHİR DEFTERDARLIĞI</p>
                <p><b class="primary">Tax Number: </b>630 006 0282</p>
                <p><b class="primary">Telefon: </b>0 (222) 236 23 50-51</p>
                <p><b class="primary">Fax: </b>0 (222) 236 23 52</p>
                <p><b class="primary">Mail: </b>teknoloji@alpata.com</p>
              </div>
              <div class="fatura-footer">E-Invoice Registered</div>
            </div>
          </div>
        </div>
        <div class="imac-frame hidden">
          <span class="loader"></span>
          <div class="imac-screen imac-slider flexslider"></div>
        </div>
      </div>
      <!--End container -->
    </div>
  </div>
  <div *ngIf="gosterilenIsleme == 6" id="f-alpteknik">
    <div class="project-preview">
      <div class="container">
        <div class="preview-header text-center">
          <a href="#portfolio-2" class="close-preview" (click)="gosterilenIsletmeGosterGizle(6)">×</a>
          <p class="preview-subtitle"></p>
          <div id="preview-content" class="col-sm-10 col-sm-offset-1" style="text-align:justify">
            <!-- <img class="img-responsive" style=" margin-bottom:30px;" src="assets/images/company/alpata.png"> -->
            <div class="fatura-card">
              <div class="fatura-card-header">
                <div style="position: relative; z-index: 3;">
                  <h1 class="mb-0">ALPTEKNİK HAVACILIK SANAYİ VE TİCARET ANOMİN ŞİRKETİ</h1>
                </div>
              </div>
              <div class="fatura-card-header-overlay"></div>
              <div class="card-body">
                <p><b class="primary">Billing Address: </b>Mustafa Kemal Mahallesi Dumlupınar Bulvarı Tepeprime İş
                  Merkezi
                  No:266 A Blok D:35 Çankaya / Ankara</p>
                <p><b class="primary">Tax Office: </b>ULUS V.D.</p>
                <p><b class="primary">Tax Number: </b>058 016 7597</p>
                <p><b class="primary">Telefon: </b>0 (312) 201 87 00</p>
                <p><b class="primary">Fax: </b>0 (312) 201 87 24</p>
                <p><b class="primary">Mail: </b>spares@alp.com.tr</p>
              </div>
              <div class="fatura-footer">E-Invoice Registered</div>
            </div>
          </div>
        </div>
        <div class="imac-frame hidden">
          <span class="loader"></span>
          <div class="imac-screen imac-slider flexslider"></div>
        </div>
      </div>
      <!--End container -->
    </div>
  </div>
  <div *ngIf="gosterilenIsleme == 8" id="f-alpatahavacilik">
    <div class="project-preview">
      <div class="container">
        <div class="preview-header text-center">
          <a href="#portfolio-2" class="close-preview" (click)="gosterilenIsletmeGosterGizle(6)">×</a>
          <p class="preview-subtitle"></p>
          <div id="preview-content" class="col-sm-10 col-sm-offset-1" style="text-align:justify">
            <div class="fatura-card">
              <div class="fatura-card-header">
                <div style="position: relative; z-index: 3;">
                  <h1 class="mb-0">ALPATA HAVACILIK SANAYİ VE TİCARET ANOMİN ŞİRKETİ</h1>
                </div>
              </div>
              <div class="fatura-card-header-overlay"></div>
              <div class="card-body">
                <p><b class="primary">Billing Address: </b>75.Yıl OSB Mahallesi 34. Cadde Numara 15 26110 Odunpazarı /
                  ESKİŞEHİR</p>
                <p><b class="primary">Tax Office: </b>ESKİŞEHİR DEFTERDARLIĞI</p>
                <p><b class="primary">Tax Number: </b>056 074 4741</p>
                <p><b class="primary">Telefon: </b>0(222) 236 84 53</p>
                <p><b class="primary">Mail: </b>alpatahavacilik@alpata.com</p>

              </div>
              <div class="fatura-footer">E-Invoice Registered</div>
            </div>
          </div>
        </div>
        <div class="imac-frame hidden">
          <span class="loader"></span>
          <div class="imac-screen imac-slider flexslider"></div>
        </div>
      </div>
      <!--End container -->
    </div>
  </div>
  <!-- End Row -->
  <!-- End Projects Container -->
  <!-- End container -->
  <!--==== Project Preview Panel (DO NOT REMOVE)====-->

  <div id="preview-scroll"></div>

  <div id="project-preview">

    <div class="container">

      <div class="preview-header text-center">
        <a class="close-preview" href="#"></a>
        <!-- <h1 class="preview-title"></h1> -->
        <p class="preview-subtitle"></p>
      </div>

      <div class="imac-frame">
        <span class="loader"></span>
        <div class="imac-screen imac-slider flexslider"></div>

      </div>
    </div>

    <div style="width:100%; position: relative; background-size:cover; background-position:center; color:black;"
      id="bgCompany">
      <div style="width:100%; height:100%; position:absolute; background: rgba(255,255,255,0.85);" id="overlay"></div>
      <div class="container">

        <div class="row">
          <div id="preview-content" class="col-sm-10 col-sm-offset-1" style="text-align:justify"></div>
        </div>
      </div>


    </div>
    <div class="container">
      <div class="preview-footer text-center">
        <a class="close-preview" href="#"></a>
      </div>
    </div>
    <!--End container -->

  </div>
  <!--End #project-preview panel-->

</section>
<!-- <div class="container-fluid " style="padding-top: 50px; padding-bottom: 50px;">
  <div class="row">
    <div class="col-md-4">
      <div class="fatura-card">
        <div class="fatura-card-header">
          <div style="position: relative; z-index: 3;">NECDET ALPATA PAZARLAMA LOJİSTİK VE TURİZM SANAYİ VE TİCARET
            ANOMİN ŞİRKETİ</div>
        </div>
        <div class="fatura-card-header-overlay"></div>
        <div class="card-body">
          <p><b>Billing Address: </b>Zafer Mahallesi Esener Sokak No:3 Tepebaşı / ESKİŞEHİR</p>
          <p><b>Tax Office: </b>ESKİŞEHİR DEFTERDARLIĞI</p>
          <p><b>Tax Number: </b>630 006 0282</p>
          <p><b>Telefon: </b>0 (222) 323 89 00</p>
        </div>
      </div>
      <div class="fatura-footer">E-Invoice Registered</div>
    </div>
    <div class="col-md-4">
      <div class="fatura-card">
        <div class="fatura-card-header">
          <div style="position: relative; z-index: 3;"> NECDET ALPATA PAZARLAMA LOJİSTİK VE TURİZM SANAYİ VE TİCARET
            ANOMİN ŞİRKETİ OTOMOTİV ŞUBESİ</div>
        </div>
        <div class="fatura-card-header-overlay"></div>
        <div class="card-body">
          <p><b>Billing Address: </b>Ankara Asfaltı 75.Yıl Mah. Çevreyolu Bulvarı No:2 Odunpazarı / ESKİŞEHİR</p>
          <p><b>Tax Office: </b>ESKİŞEHİR DEFTERDARLIĞI</p>
          <p><b>Tax Number: </b>630 006 0282</p>
          <p><b>Telefon: </b>0 (222) 228 03 30</p>
        </div>
        <div class="fatura-footer">E-Invoice Registered</div>
      </div>
    </div>
    <div class="col-md-4">
      <div class="fatura-card">
        <div class="fatura-card-header">
          <div style="position: relative; z-index: 3;">ALPATA SİGORTA ARACILIK HİZMETLERİ LİMİTED ŞİRKETİ</div>
        </div>
        <div class="fatura-card-header-overlay"></div>
        <div class="card-body">
          <p><b>Billing Address: </b>Ankara Asfaltı 75. Yıl Mah. Çevreyolu Bulvarı No:2 Odunpazarı / ESKİŞEHİR</p>
          <p><b>Tax Office: </b>ESKİŞEHİR DEFTERDARLIĞI</p>
          <p><b>Tax Number: </b>055 004 6564</p>
          <p><b>Telefon: </b>0 (222) 228 03 30</p>
        </div>
        <div class="fatura-footer">E-Invoice Registered</div>
      </div>
    </div>
    <div class="col-md-4">
      <div class="fatura-card">
        <div class="fatura-card-header">
          <div style="position: relative; z-index: 3;">ALP HAVACILIK SANAYİ VE TİCARET ANOMİN ŞİRKETİ</div>
        </div>
        <div class="fatura-card-header-overlay"></div>
        <div class="card-body">
          <p><b>Billing Address: </b>75.Yıl OSB Mahallesi 8. Cadde 26110 Odunpazarı / ESKİŞEHİR</p>
          <p><b>Tax Office: </b>ESKİŞEHİR DEFTERDARLIĞI</p>
          <p><b>Tax Number: </b>055 004 4545</p>
          <p><b>Telefon: </b>0 (222) 236 13 00</p>
        </div>
        <div class="fatura-footer">E-Invoice Registered</div>
      </div>
    </div>
    <div class="col-md-4">
      <div class="fatura-card">
        <div class="fatura-card-header">
          <div style="position: relative; z-index: 3;"> NECDET ALPATA PAZARLAMA LOJİSTİK VE TURİZM SANAYİ VE TİCARET
            ANOMİN ŞİRKETİ TEKNOLOJİ ŞUBESİ</div>
        </div>
        <div class="fatura-card-header-overlay"></div>
        <div class="card-body">
          <p><b>Billing Address: </b>75.Yıl OSB Mahallesi Bilim Caddesi(Yazılım Kule) No:5 İç Kapı No:401 Odunpazarı /
            ESKİŞEHİR</p>
          <p><b>Tax Office: </b>ESKİŞEHİR DEFTERDARLIĞI</p>
          <p><b>Tax Number: </b>630 006 0282</p>
          <p><b>Telefon: </b>0 (222) 236 23 50-51</p>
        </div>
        <div class="fatura-footer">E-Invoice Registered</div>
      </div>
    </div>
    <div class="col-md-4">
      <div class="fatura-card">
        <div class="fatura-card-header">
          <div style="position: relative; z-index: 3;">ALPTEKNİK HAVACILIK SANAYİ VE TİCARET ANOMİN ŞİRKETİ</div>
        </div>
        <div class="fatura-card-header-overlay"></div>
        <div class="card-body">
          <p><b>Billing Address: </b>Mustafa Kemal Mahallesi Dumlupınar Bulvarı Tepeprime İş Merkezi No:266 A Blok D:35
            Çankaya / Ankara</p>
          <p><b>Tax Office: </b>ULUS V.D.</p>
          <p><b>Tax Number: </b>058 016 7597</p>
          <p><b>Telefon: </b>0 (312) 201 87 00</p>
        </div>
        <div class="fatura-footer">E-Invoice Registered</div>
      </div>
    </div>
    <div class="col-md-4"></div>
    <div class="col-md-4">
      <div class="fatura-card">
        <div class="fatura-card-header">
          <div style="position: relative; z-index: 3;">ALPATA HAVACILIK SANAYİ VE TİCARET ANOMİN ŞİRKETİ</div>
        </div>
        <div class="fatura-card-header-overlay"></div>
        <div class="card-body">
          <p><b>Billing Address: </b>75.Yıl OSB Mahallesi 34. Cadde Numara 15 26110 Odunpazarı / ESKİŞEHİR</p>
          <p><b>Tax Office: </b>ESKİŞEHİR DEFTERDARLIĞI</p>
          <p><b>Tax Number: </b>056 074 4741</p>
          <p><b>Telefon: </b>0(222) 236 84 53</p>
        </div>
        <div class="fatura-footer">E-Invoice Registered</div>
      </div>
    </div>
  </div>
</div> -->
<footer id="main-footer" class="color-bg light-typo">
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-6">
        <span id="copyright">
          &copy; {{ currentYear }}
        </span> <a href="http://alpata.com/" style="text-decoration: none;"> ALPATA</a>
      </div>
      <div class="col-md-6 text-right">
        <a href="/en/fatura" style="text-decoration: none;">Invoice Information</a>
      </div>
    </div>
  </div>
</footer>
